export default __webpack_public_path__ + "static/media/icon1-m.01666e4b.png";